import React from 'react';
const AdminGallery = () => <div className="min-h-screen p-8">Admin Gallery Management</div>;
export default AdminGallery; 